<div class="number-counter-container">
  <div class="number-counter" data-id="statsCount">{{counter}}</div>
  <div class="number-counter-label">{{label}}</div>
</div>
